// extracted by mini-css-extract-plugin
export var label = "_c5-5";
export var slideContainer = "_c5-0";
export var slider = "_c5-1";
export var sliderLg = "_c5-4";
export var sliderMd = "_c5-3";
export var sliderSm = "_c5-2";